import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isOpen: boolean
}

export const Header = styled(ButtonPlain)<Props>`
	display: flex;
	width: 100%;
	align-items: center;
	column-gap: 4px;
	font-family: ${helpers.font.family.header};
	padding: 12px;
	border-radius: ${({ isOpen }) => (isOpen ? '4px 4px 0 0' : '4px')};

	> :first-child {
		margin-bottom: 4px;
	}
`
